import { mantyIntegrations } from 'routes/IntegrationsList/fullIntegrationList';

export const getSoftwareDomain = (software: string) => {
    const integration = mantyIntegrations.find((i) => i.software === software);
    return integration?.type;
};
